import Tooltip from './tooltip'

/**
 * Component plugin for global use in the interface.
 * Activated in application.js.
 * Can be used in any component template:
 * ```
 * <cp-help msg="Tooltip message here"></cp-help>
 * ```
 * or, for localization reference to key 'help.'
 * ```
 * <cp-help i18n="vm.callwait"></cp-help>
 *
 * ```
 */
export default {
  install: function (Vue) {
    Vue.component('cp-help', Tooltip)
  }
}
